import { TwitterOnboardingPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(TwitterOnboardingPage);
